// extracted by mini-css-extract-plugin
module.exports = {"section":"_3utjY","narrow":"_1kiRP","headingLink":"_1W_qR","mainCategoryLink":"hnqEj","delimiter":"_1CrwV","list":"_3qZVX","itemLink":"_2tcT-"};